/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Research_Faq_3_QuestionInputs */

const en_svc_research_faq_3_question = /** @type {(inputs: Svc_Research_Faq_3_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How much does a research agent cost?`)
};

const lv_svc_research_faq_3_question = /** @type {(inputs: Svc_Research_Faq_3_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cik maksā izpētes aģents?`)
};

/**
* | output |
* | --- |
* | "How much does a research agent cost?" |
*
* @param {Svc_Research_Faq_3_QuestionInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const svc_research_faq_3_question = /** @type {((inputs?: Svc_Research_Faq_3_QuestionInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Research_Faq_3_QuestionInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_svc_research_faq_3_question(inputs)
	return en_svc_research_faq_3_question(inputs)
});